import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 実績履歴出力クラス
 *
 * @export DeleteWorkTableService
 * @class DeleteWorkTableService
 * @extends {PlessResponder}
 */
@Injectable()
export class DeleteWorkTableService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private vo: any;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteWorkTableService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        SessionId: this.vo.sessionId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof DeleteWorkTableService
   */
  execute(vo: any, successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW0800DeleteWorkTable', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteWorkTableService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
